module.exports = __webpack_public_path__ + "img/error.046a0d3b.gif";